<template>
    <div class="chart-box">
        <header>
            <p>{{ chart.title }}</p>
            <select class="period" v-model="option" @change="updateChart(true)"><option v-for="period in options">{{ period }}</option></select>
            <select class="split" v-model="split" @change="updateChart(true)"><option v-for="split in splits">{{ split }}</option></select>
        </header>
        <canvas></canvas>
    </div>
</template>

<script>

import Chart from 'chart.js';
import WebSoc from '../utils/WebSoc.js'
import ChartConfig from '../utils/ChartConfig.js'
import { mapMutations } from 'vuex'

export default {
    props: ['name'],
    computed: {
        client_id () { return this.$store.state.client_id },
        customers () { return this.$store.state.customers },
        chartUpdate () { return this.$store.state.chartUpdate }
    },
    data () {
        return {
            option: '7 days',
            options: ['7 days','1 month','3 months','1 year','all'],
            split: 'hr',
            splits: ['min','hr','day','week'],
            chart: {
                title: 'App Access'
            },
            chartJS: false
        }
    },
    created () {
        this.chart = ChartConfig.demo;
    },
    mounted () {
        this.name == 'date' && this.updateChart();
    },
    methods: {
        updateChart ( force ) {

            var { split, option } = this;

            var db = this.client_id+'-customers'
            
            var startDate = new Date();
            
            var periodDate;

            switch ( option ) {
                case '7 days':
                    startDate.setDate(startDate.getDate() - 7);
                    break;
                case '1 month':
                    startDate.setMonth(startDate.getMonth() - 1);
                    break;
                case '3 months':
                    startDate.setMonth(startDate.getMonth() - 3);
                    break;
                case '1 year':
                    startDate.setMonth(startDate.getMonth() - 12); 
                case 'all':
                    startDate = new Date(2020,0,1);               
            }
            
            const makeChart = customers => {
                
                this.setValue({ customers });
                this.setValue({ chartUpdate: Date.now() });

                var dates = [];
                customers.forEach(c => {
                    if ( !Array.isArray(c.lands) ) return console.log('!lands',db,c.name);
                    dates = dates.concat(c.lands.filter(d => d > startDate.valueOf()));                   
                });
                dates.sort((a,b) => a < b ? -1 : 1);                
                periodDate = new Date(dates[0]);

                var data = [];
                var period;

                data.push(period = stepPeriod(split,periodDate));

                for ( var i = 0; i < dates.length; ) {
                    while ( dates[i] && dates[i] < periodDate.valueOf() ) {
                        i++;
                        period.y++;  
                    }
                    while ( dates[i+1] && dates[i+1] > periodDate.valueOf() ) {
                        data.push(period = stepPeriod(split,periodDate));
                    }
                    //stepPeriod(split,periodDate);

                    // or

                    data.push(period = stepPeriod(split,periodDate));
                }
                while ( periodDate.valueOf() < Date.now() ) {
                    data.push(stepPeriod(split,periodDate));
                }

                function stepPeriod(split,date) {
                    switch ( split ) {
                            case 'hr':
                                date.setHours(date.getHours() + 1);
                            break;   
                            case 'min':
                                date.setMinutes(date.getMinutes() + 1);
                            break;       
                            case 'day':
                                date.setDate(date.getDate() + 1);
                            break; 
                            case 'week':
                                date.setDate(date.getDate() + 7);
                            break;                           
                        }
                    return { x: new Date(date), y: 0 }    
                }
                var canvas = this.$el.querySelector('canvas');
                this.chartJS && this.chartJS.destroy();
                this.chartJS = new Chart(canvas, {
                                    type: 'line',
                                    data: {
                                        datasets: [
                                            {
                                                label: 'Member Access',
                                                data: data,
                                                backgroundColor: [
                                                    'rgba(54,73,93,.5)', // Blue
                                                ],
                                                borderColor: [
                                                    'rgba(54,73,93,.5)',
                                                ],
                                                borderWidth: 0
                                            }
                                        ]                                            
                                    },
                                    options: {
                                        scales: {
                                        xAxes: [{
                                            type: 'time',
                                            time: {
                                                unit: 'day',
                                                displayFormats: {
                                                    'day': 'ddd DD/MM'
                                                }

                                            }
                                        }]
                                    }
                                    }
                                }); 
            }
            
            if ( !force && this.customers.length > 0 && Date.now() - this.chartUpdate < 90000 ) return makeChart(this.customers); 

            WebSoc.SEND('search',{ DB: db, find: {}, project: { joined: 1, lands: 1, name: 1 } },customers => {
                console.log('search makeChart');
                makeChart(customers);
            })

        },
        ...mapMutations([
            'setValue'
        ])
    }
}

</script>

<style scopped lang="scss">
.chart-box {
    width: 800px;
    padding: 10px;
    padding-bottom: 20px;
    border: 1px solid #c0c0c0;
    position: relative;
    header {
        text-align: center;
        font-weight: bold;
        select {
            position: absolute;
            top: 0px;
            right: 0px;
            width: 120px;
            margin: 5px;
            &.period {
                right: 125px;
            }
        }
    }
    canvas {
        width: 100%;
        height: 100%;
    }
}
</style>